import { render, staticRenderFns } from "./ImmediateDiscountInfo.vue?vue&type=template&id=a827849c&scoped=true&"
import script from "./ImmediateDiscountInfo.vue?vue&type=script&lang=ts&"
export * from "./ImmediateDiscountInfo.vue?vue&type=script&lang=ts&"
import style0 from "./ImmediateDiscountInfo.vue?vue&type=style&index=0&id=a827849c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a827849c",
  null
  
)

export default component.exports